// extracted by mini-css-extract-plugin
export var closeButton = "bM_fH";
export var dialogWrapper = "bM_fJ";
export var mainContent = "bM_X";
export var modalWrapper = "bM_fG";